const nameByServiceType = {
  general: 'My Bespoke Room',
  design: 'Designer Chat',
  personal_shopper: 'Shopping Support',
};

// Sits under the circle in the rooms rail, so it has ~60px to work with. Used
// when a room has nobody assigned yet - otherwise the person's short name wins.
const captionByServiceType = {
  general: 'chat',
  design: 'design',
  personal_shopper: 'shopping',
  mediaFiles: 'docs',
};

// The rooms that are with a person, and so show that person's avatar.
const staffedServiceTypes = ['design', 'personal_shopper'];

const allowedToChatType = ['design', 'personal_shopper'];

const ProjectMediaTypes = {
  project_media: 'project_media',
  project_documents: 'project_documents',
  project_links: 'project_links',
  all: 'all',
};

const CustomPreviewIcon = {
  document: 'icon-document',
  image: null,
  link: 'icon-link',
};

const ControlsTypeIcon = {
  download: 'download-icon',
};

const MediaFileListConfig = {
  [ProjectMediaTypes.project_media]: {
    direction: 'row',
    iconClass: null,
    preview: true,
    controls: [],
  },
  [ProjectMediaTypes.project_documents]: {
    direction: 'row',
    iconClass: null,
    preview: false,
    controls: [],
  },
  [ProjectMediaTypes.project_links]: {
    direction: 'col',
    iconClass: CustomPreviewIcon.link,
    preview: false,
    controls: [],
  },
  [ProjectMediaTypes.all]: {
    direction: 'row',
    iconClass: null,
    preview: false,
    controls: ['download'],
  },
};

const MediaFileHeaderItems = [
  {
    label: 'Images & Docs',
    type: ProjectMediaTypes.all,
  },
  { label: 'Links', type: ProjectMediaTypes.project_links },
];

const getChatName = chat => {
  return chat.name || nameByServiceType[chat.service_type || 'general'];
};

const getChatCaption = chat => {
  return (
    (chat.assignee && chat.assignee.name) || captionByServiceType[chat.service_type || 'general']
  );
};

export {
  getChatName,
  getChatCaption,
  nameByServiceType,
  captionByServiceType,
  staffedServiceTypes,
  CustomPreviewIcon,
  allowedToChatType,
  MediaFileHeaderItems,
  ProjectMediaTypes,
  MediaFileListConfig,
  ControlsTypeIcon,
};



// WEBPACK FOOTER //
// ./app/javascript/customer_chat/components/chat/shared/contstants/constants.js